import {qrcodeAction} from "./store";
import HashJson from "../../core/utils/hash-json";
import callPeerRemoteModule from "../../core/utils/callPeerRemoteModule";

const hashJson = new HashJson();

let previousHash = null;

const MONITORED_ACTION = [
  "optionWindow/setSendData",
  "optionWindow/setSendDataRemove",
  "optionWindow/loadDataAndSet/fulfilled",
  // "optionWindow/setNotes"
]


const webglStateMiddleware = (store) => (next) => (action) => {
  if (MONITORED_ACTION.includes(action.type)) {

    if (action.type === "optionWindow/setSendData" && action.payload.key === "COLORWAY") {
      return next(action);
    }


    return Promise.all([next(action)]).then(() => {
      const dispatch = store.dispatch;
      const state = store.getState()["optionWindow"];
      const themeState = store.getState()["theme"];
      const loading = store.getState()["intro"].loadingState;

      const currentHash = handleQRCodeGeneration(state, dispatch);

      if (currentHash !== previousHash) {

        if (loading === "end" || loading === "assetLoad:end") {
          const webglPayload = prepareWebGLPayload(state, action);
          sendWebGLData(themeState.connectMode, webglPayload, loading);
          previousHash = currentHash;
        } else {
          console.log("loading state : ", loading);
        }
      }
    });
  }

  return next(action);
};


function handleQRCodeGeneration(state, dispatch) {
  if (state.currentVehicle) {
    const copyConfigData = JSON.parse(JSON.stringify(state.CONFIG_DATA));
    const configIncludingProductId = {
      productId: state.currentVehicle.id,
      ...copyConfigData
    };

    const hash = hashJson.hash(configIncludingProductId).substring(0, 7);
    dispatch(qrcodeAction.setQRcode(hash));
    return hash;
  }
  return null;
}

function prepareWebGLPayload(state, action) {
  const filteredConfigData = Object.keys(state.CONFIG_DATA).reduce((acc, key) => {
    if (key !== "" && key !== "COLORWAY" && key !== "INT_KEY" && key !== "INT_SECONDARY" && key !== "INT_THIRD") {
      acc[key] = state.CONFIG_DATA[key];
    }
    return acc;
  }, {});

  const { THEME } = state.CONFIG_DATA;

  if (action.payload.key === 'THEME') {
    if (THEME && THEME.CODE === 'BLACK') {
      return { THEME };
    }
  } else {
    if (THEME && THEME.CODE === 'STANDARD') {
      const { THEME: _, ...filteredEtc } = filteredConfigData;
      return filteredEtc;
    }
  }

  return filteredConfigData;
}

async function sendWebGLData(connectMode, webglPayload, loadingState) {
  if (connectMode === "remote") {
    const peer = await callPeerRemoteModule(connectMode);
    peer.conn.sendData("sendData", webglPayload);
    peer.conn.sendData("dispatch", {
      action: "introAction",
      func: "setLoadingState",
      payload: loadingState
    });
  } else if (connectMode === "web") {
    if (window && (webglPayload || loadingState === "assetLoad:end")) {
      window.postMessage(webglPayload, "*");
    }
  }
}


export default webglStateMiddleware;
